import React from 'react';
import css from './styles.css';
import logo from '../../../../icons/folio.png';

function OrgLoader() {
  return (
    <div className={css.container}>
      <div className={css.loader}>
        <img
          src={logo}
          alt=""
        />
      </div>
    </div>
  );
}

OrgLoader.propTypes = {};

export default OrgLoader;
